import { render, staticRenderFns } from "./viewNoticeDetail.vue?vue&type=template&id=3e97fe4b&scoped=true"
import script from "./viewNoticeDetail.vue?vue&type=script&lang=js"
export * from "./viewNoticeDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e97fe4b",
  null
  
)

export default component.exports